import { render, staticRenderFns } from "./remarkSet.vue?vue&type=template&id=79dd2a70&scoped=true"
import script from "./remarkSet.vue?vue&type=script&lang=js"
export * from "./remarkSet.vue?vue&type=script&lang=js"
import style0 from "./remarkSet.vue?vue&type=style&index=0&id=79dd2a70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dd2a70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79dd2a70')) {
      api.createRecord('79dd2a70', component.options)
    } else {
      api.reload('79dd2a70', component.options)
    }
    module.hot.accept("./remarkSet.vue?vue&type=template&id=79dd2a70&scoped=true", function () {
      api.rerender('79dd2a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/remarkSet.vue"
export default component.exports